import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Platform, NavController } from '@ionic/angular';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
// Redux
import { Store } from '@ngrx/store';
import { AppState } from './store/app.reducers';
import * as personalizationClientActions from './store/actions/personalizationClient.actions';
// import { FCM } from '@ionic-native/fcm/ngx';
import { Constants } from '../providers/constants/constants';
import { ToolsService } from './service/tools/tools.service';
import { FirebaseanalyticsService } from './service/firebaseanalytics/firebaseanalytics.service';
import { PushService } from './service/push/push.service';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  dataPersonalizationClientSubs: Subscription;
  private pushForegroundSub: Subscription;
  private pushTokenReadySub: Subscription;
  private readonly processedPushIds = new Set<string>();
  private lastPushCleanupAt = Date.now();
  // public selectedIndex = 0;
  // public appPages = [
  //   {
  //     title: 'Inbox',
  //     url: '/folder/Inbox',
  //     icon: 'mail'
  //   },
  //   {
  //     title: 'Outbox',
  //     url: '/folder/Outbox',
  //     icon: 'paper-plane'
  //   },
  //   {
  //     title: 'Favorites',
  //     url: '/folder/Favorites',
  //     icon: 'heart'
  //   },
  //   {
  //     title: 'Archived',
  //     url: '/folder/Archived',
  //     icon: 'archive'
  //   },
  //   {
  //     title: 'Trash',
  //     url: '/folder/Trash',
  //     icon: 'trash'
  //   },
  //   {
  //     title: 'Spam',
  //     url: '/folder/Spam',
  //     icon: 'warning'
  //   }
  // ];
  // public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  constants = Constants;
  dataUser: any = {};
  constructor(
    private store: Store<AppState>,
    private elementRef: ElementRef,
    private router: Router,
    private platform: Platform,
    public navController: NavController,
    private toolsService: ToolsService,
    private firebaseanalyticsService: FirebaseanalyticsService,
    private pushService: PushService
    // private fcm: FCM
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      CapacitorApp.addListener('backButton', ({ canGoBack }) => { if (!canGoBack) { CapacitorApp.exitApp(); } else { window.history.back(); } });
      SplashScreen.hide().catch(() => {});
      this.getPersonalizacion();
      this.validateActiveSession();
      this.firebaseanalyticsService.setEnabledFirebaseAnalytics(true);
      // Tras obtener un token válido se emite pushTokenReady$ y se (re)registra el listener de primer plano.
      // Si el primer getToken falla (sin permiso) y el usuario activa push en Configuración, el segundo getToken vuelve a emitir y aquí se suscribe de nuevo.
      this.pushTokenReadySub = this.pushService.pushTokenReady$.subscribe(() => {
        this.escucharNotificacionesPush();
      });
      this.pushService.getToken().then((token) => {
        this.pushService.debugLog(
          'initializeApp: getToken',
          token ? `ok (${token.length} caracteres)` : 'sin token (permiso pendiente o no soportado)'
        );
      }).catch((err) => {
        console.error('[Push] initializeApp getToken', err);
      });
    });
  }

  ngOnDestroy() {
    this.pushForegroundSub?.unsubscribe();
    this.pushTokenReadySub?.unsubscribe();
    this.dataPersonalizationClientSubs?.unsubscribe();
  }

  ngOnInit() {
    this.dataUser = JSON.parse(localStorage.getItem(this.constants.localStorage.user));
    // const path = window.location.pathname.split('folder/')[1];
    // if (path !== undefined) {
    //   this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    // }
    this.router.events.pipe(
        filter( event => event instanceof ActivationEnd ),
        filter( (event: ActivationEnd) => event.snapshot.firstChild === null  ),
        map( (event: ActivationEnd) => event.snapshot.data ),
      ).subscribe((data)=> {
        try {
          if (data.titlePage) {
            this.firebaseanalyticsService.logEvent('page_view', {title: data.titlePage, url: this.router.url});
            this.firebaseanalyticsService.setScreenName(data.titlePage);
          }
        } catch (error) {
          console.error('Error al registrar analytics:', error);
        }
      });
  }

  /**
   * color_principal del API sin #; rechaza undefined/vacío/formato inválido (evita `#undefined`).
   */
  private normalizePrincipalHex(raw: string | undefined): string | null {
    if (raw == null || typeof raw !== 'string') {
      return null;
    }
    const s = raw.trim().replace(/^#/, '');
    return /^[0-9A-Fa-f]{6}$/.test(s) ? s : null;
  }

  /**
   * @description obtiene la personalización del store y setea el color primario en el app
   */
  getPersonalizacion(){
    this.dataPersonalizationClientSubs = this.store.select('personalizationClient').subscribe(({data}) => {
      const hex = this.normalizePrincipalHex(data?.color_principal);
      if (data !== null && hex) {
        this.elementRef.nativeElement.style.setProperty('--ion-color-primary', `#${hex}`);
        this.elementRef.nativeElement.style.setProperty('--ion-text-color', `#${hex}`);
      }
    });
  }

  validateActiveSession() {
    // si existe un token de sesion pasa al home
    const currentPath = window.location?.pathname || '';
    const isInitialPath = currentPath === '/' || currentPath === '' || currentPath === '/sliderhome' || currentPath === '/login';

    if (localStorage.getItem(this.constants.localStorage.token) && localStorage.getItem(this.constants.localStorage.token) !== 'undefined') {
      this.store.dispatch(personalizationClientActions.triggerPersonalizationClientInit({subDominio: this.dataUser.organizaciones.sub_dominio}));
      // Solo redirigir al home si estamos en rutas iniciales. Si el usuario recargó en otra ruta, no sobrescribirla.
      if (isInitialPath) {
        this.navController.navigateRoot('/home');
      }
    } else if (localStorage.getItem(this.constants.localStorage.initAppSlider) === 'true') {
      // Solo llevar a login si estamos en rutas iniciales, para no sobreescribir rutas profundas compartidas o recargadas
      if (isInitialPath) {
        this.toolsService.clearDataRedirectLogin();
        this.navController.navigateRoot('/login');
      }
    }
  }

  escucharNotificacionesPush() {
    this.pushForegroundSub?.unsubscribe();
    this.pushService.debugLog('escucharNotificacionesPush: (re)suscripción a listeners de primer plano');
    this.pushForegroundSub = this.pushService.onMessageReceived().subscribe({
      next: (notificacion: any) => {
      this.pushService.debugLog('notificación recibida (foreground/listener)', {
        title: notificacion?.title,
        tap: notificacion?.tap,
        messageType: notificacion?.messageType
      });
      const pushId = this.buildPushId(notificacion);
      if (this.processedPushIds.has(pushId)) {
        return;
      }
      this.processedPushIds.add(pushId);
      this.cleanupProcessedPushIds();
      // if(notificacion?.messageType === 'notification'){
      if(notificacion?.tap !== 'background'){
        const dataNotificacionPus = {
          titulo: notificacion.title,
          mensaje: notificacion.body
        };
        // En web foreground mostramos notificacion del navegador (tipo Chrome)
        if (Capacitor.getPlatform() === 'web' && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          new Notification(dataNotificacionPus.titulo || 'Notificacion', {
            body: dataNotificacionPus.mensaje || '',
          });
        }
        // esta nottificacion sera temporal
        this.toolsService.alertNotificacionSimple(dataNotificacionPus);
        // this.pushService.addNotificationToList(notificacion);
      }
    }, error: (e) => {
      this.pushService.debugLog('escucharNotificacionesPush: error en stream', e);
      console.error('[Push] escucharNotificacionesPush', e);
    }});
  }

  private buildPushId(notificacion: any): string {
    const messageId = notificacion?.data?.['google.message_id']
      || notificacion?.data?.messageId
      || notificacion?.messageId;

    if (messageId) {
      return `id:${messageId}`;
    }

    const title = notificacion?.title || '';
    const body = notificacion?.body || '';
    const tap = notificacion?.tap || '';
    const timestampBucket = Math.floor(Date.now() / 10000); // bucket de 10s para deduplicar repetidos inmediatos
    return `fallback:${title}|${body}|${tap}|${timestampBucket}`;
  }

  private cleanupProcessedPushIds() {
    const now = Date.now();
    const shouldCleanup = now - this.lastPushCleanupAt > 60000 || this.processedPushIds.size > 200;
    if (!shouldCleanup) {
      return;
    }

    this.processedPushIds.clear();
    this.lastPushCleanupAt = now;
  }
}
